import axios from 'axios'
import wujieVue from 'wujie-vue2'
import { Message, Loading } from 'element-ui'
import { baseURL, cozeBaseURL, defaultTimeout } from '@/utils/const'
import { getTokenCookie } from '@/utils/cookie'

axios.defaults.baseURL = baseURL
axios.defaults.timeout = defaultTimeout
// axios.defaults.withCredentials = true

const matchPaths = ['/control/updateRecord/list', '/control/bus/getInfo'];
/**
 * http request 拦截器
 */
axios.interceptors.request.use(
    (config) => {
        // console.log('http request 拦截')
        // config.data = JSON.stringify(config.data)
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
        if (config.url == '/operator/file/uploadFile') {
            config.headers['Content-Type'] = 'multipart/form-data;charset=utf-8'
        }
        config.headers.Authorization = `Bearer ${getTokenCookie()??''}`
        if (matchPaths.some(path => config.url.includes(path))) {
            config.headers['Authorization'] = '';
        }
        if (['/api/passport/web/email/login/', '/api/passport/web/email/register/v2/', '/api/passport/web/logout/'].some(item => item == config.url)) {
            config.baseURL = cozeBaseURL
        }
        return config
    },
    (error) => {
        console.log(error)
        return Promise.reject(error)
    }
)

/**
 * http response 拦截器
 */
axios.interceptors.response.use(
    (res) => {
        // console.log('http response 拦截')
        // console.log(res)
        if (res.config.baseURL != cozeBaseURL && res.config.responseType != 'blob' && res.data?.code != 200) {
            Message({ type: 'error', message: res.data?.msg || '出错啦，请刷新重试' })
            if (res.data?.code == 401) {
                wujieVue.bus.$emit('appLogout')
            }
        }
        return res.data
    },
    (error) => {
        console.log(error)
        Message({ type: 'error', message: error?.message || '出错啦，请联系管理员' })
        return Promise.reject(error)
    }
)

/**
 * 封装get请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params = {}, timeout = defaultTimeout, responseType) {
    let loading = null
    if (timeout > defaultTimeout) {
        loading = Loading.service({
            customClass: 'loading-syws',
            spinner: 'syws-icon-loading',
            body: true,
            lock: true,
            text: '正在处理，请稍等...',
            background: 'rgba(0, 0, 0, 0.7)',
        })
    }
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params,
                timeout,
                responseType,
            })
            .then((response) => {
                if (timeout > defaultTimeout && loading) { loading.close() }
                resolve(response)
            })
            .catch((error) => {
                if (timeout > defaultTimeout && loading) { loading.close() }
                reject(error)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data, timeout = defaultTimeout) {
    let loading = null
    if (timeout > defaultTimeout) {
        loading = Loading.service({
            customClass: 'loading-syws',
            spinner: 'syws-icon-loading',
            body: true,
            lock: true,
            text: '正在处理，请稍等...',
            background: 'rgba(0, 0, 0, 0.7)',
        })
    }
    return new Promise((resolve, reject) => {
        // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
        axios.post(url, data, { timeout }).then( // qs.stringify(data)
            (response) => {
                if (timeout > defaultTimeout && loading) { loading.close() }
                resolve(response)
            },
            (error) => {
                if (timeout > defaultTimeout && loading) { loading.close() }
                reject(error)
            }
        )
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data) {
    return new Promise((resolve, reject) => {
        axios.put(url, data).then(
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error)
            }
        )
    })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(url, data) {
    return new Promise((resolve, reject) => {
        axios.delete(url, { data }).then(
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error)
            }
        )
    })
}